module.exports = __webpack_public_path__ + "media/img/corporate/pac3-818f4079c0b94ba67fe07a79443410fa.svg";